module.exports = __webpack_public_path__ + "veryHigh-06b076472cbc7f24318a550ef15cd9d1.png";